"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledButtonCard = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
//
// properties
//
const config_1 = require("../../../assets/styles/config");
exports.StyledButtonCard = styled_components_1.default.div `
  align-items: center;
  border-top: 1px solid ${config_1.colors.pavement};
  display: flex;
  font: Bold ${config_1.fontSizes.base} ${config_1.fontFamilies.primary};
  height: 65px;
  justify-content: center;
  padding: 0 0 5px;
  width: 100%;

  @media ${config_1.device.tablet} {
    justify-content: start;
  }
`;
